import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslate } from '../TranslationText';

/**
 * Clean checkbox with React Hook Form integration.
 * Uses native HTML checkbox (no NetaqInput wrapper).
 *
 * @param {string} name - Form field name
 * @param {string} label - Label text
 * @param {boolean} required - Show required asterisk
 * @param {boolean} disabled - Disable checkbox
 * @param {object} rules - Validation rules
 * @param {React.ReactNode} children - Optional custom label content (links, etc.)
 */
export default function FormCheckbox({
    name,
    label,
    required = false,
    disabled = false,
    rules,
    children,
    onChange,
    noValidate = false,
}) {
    const { control, formState: { errors } } = useFormContext();
    const { translate } = useTranslate();

    const validationRules = {
        ...(required && !noValidate && {
            required: translate('web.requiredField', 'Required Field'),
        }),
        ...rules,
    };

    const fieldError = name.split('.').reduce((obj, key) => obj?.[key], errors);

    return (
        <div className="mb-2">
            <Controller
                name={name}
                control={control}
                rules={validationRules}
                render={({ field }) => (
                    <div className="me-3 form-check mb-0">
                        <input
                            type="checkbox"
                            id={name}
                            className="form-check-input mb-0"
                            checked={!!field.value}
                            onChange={(e) => {
                                field.onChange(e.target.checked);
                                if (onChange) onChange(e);
                            }}
                            disabled={disabled}
                        />
                        <label className="ms-1 form-check-label mb-0 text-black" htmlFor={name}>
                            {children || (
                                <>
                                    {label}{' '}
                                    {required && (
                                        <i style={{ color: 'red', margin: 'auto 2px' }}>*</i>
                                    )}
                                </>
                            )}
                        </label>
                    </div>
                )}
            />

            {fieldError && (
                <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>
                    {fieldError.message || translate('web.requiredField', 'Required Field')}
                </div>
            )}
        </div>
    );
}
